import styled, { css } from 'styled-components'
import CommonButton from 'components/Button/CommonButton'
import theme from 'theme_'
import { Font14 } from 'components/Typography'
import { WhiteBlock } from 'components/Layout'

const baseFlex = css`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const HomeLicensingContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const HomeLicensingHeader = styled.div`
  ${baseFlex};
  justify-content: space-between;
  margin-bottom: 40px;
`

export const VisitStoreButton = styled(CommonButton)`
  && {
    appearance: none;
  }
  text-transform: capitalize;
  font-weight: 900;
  height: 40px;
  padding: 12px 32px;
  border-radius: 8px;
  background: transparent;
`

export const HomeLicensesMobileContainer = styled(WhiteBlock)`
  width: 100%;
  gap: ${theme.spacing.base};
  ${Font14}
`

export const HomeNoLicenses = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 96px;
  color: ${theme.colors.darkeyGrey};
  background: ${theme.colors.white};
  border-radius: 8px;
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.02);
`
